export const APP_VERSION = "0.14.0";

// Also expose globally for quick inspection / non-React contexts
// (kept tiny and tree-shake friendly)
(function exposeGlobal(v: string) {
  const w = globalThis as any;
  w.qq = w.qq || {};
  w.qq.appVersion = v;
})(APP_VERSION);

